import { Time } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/types'
import { useEffect } from 'react'

export const useInitializeAndCleanupTime = (
    times: Time[],
    onChange: (index: string | null) => void
): void => {
    useEffect(() => {
        onChange(times.length ? '0' : null)

        return () => onChange(null)
    }, [times, onChange])
}
